import { render, staticRenderFns } from "./MarketPlace.vue?vue&type=template&id=3769bd92&scoped=true"
import script from "./MarketPlace.vue?vue&type=script&lang=js"
export * from "./MarketPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3769bd92",
  null
  
)

export default component.exports